import { createI18n } from "vue-i18n";
import Utils from "@/utils/Utils";
import * as fr from "./locales/fr/";
import * as en from "./locales/en/";
import * as de from "./locales/de/";

const messages = { fr, en, de };
const numberFormats = {
  fr: {
    currency: {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    number: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
  },
};
const datetimeFormats = {
  fr: {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    shortDate: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    shortHour: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
  en: {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    shortDate: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    shortHour: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
  de: {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    shortDate: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    shortHour: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
  },
};

const i18n = createI18n({
  legacy: false,
  fallbackLocale: "fr",
  locale: Utils.getCookie("user-language") || "fr",
  messages: messages,
  numberFormats: numberFormats,
  datetimeFormats: datetimeFormats,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});

export default i18n;
